/// <reference path="pegs/FootchinkoItem.ts"/>

import { FootchinkoItem } from "./pegs/FootchinkoItem";

import { GameConstants } from "../GameConstants";

import { AudioManager } from "../AudioManager";

import { DailyRewardItemsContainer } from "./DailyRewarditemsContainer";

import { GameManager } from "../GameManager";

export class RewardItem extends FootchinkoItem {

    public trunkHit: boolean;

    private rewardType: string;
    private rays: Phaser.Image;
    private reward: Phaser.Image;

    constructor(game: Phaser.Game, x: number, y: number, rewardType: string) {

        super(game, x, y, "texture_atlas_6", false, false);

        this.rewardType = rewardType;

        this.trunkHit = false;

        this.addReward();
    }

    public setBody(): void {

        this.body.setRectangle(96, 70, 0, 22, 0);
        this.body.static = true;
        this.body.data.shapes[0].sensor = true;
        this.body.onBeginContact.add(this.onRewardHit, this);
    }

    public setView(): void {

        super.setView();

        this.name = GameConstants.DAILY_REWARD_ITEM;

        this.frameName = "trunk_prize0001";
        this.animations.add("open-prize", Phaser.Animation.generateFrameNames("trunk_prize", 1, 15, "", 4));
        this.animations.add("open-not-chosen", Phaser.Animation.generateFrameNames("trunk_unchosen", 1, 15, "", 4));
    }

    public openTrunk(): void {

        this.game.time.events.add(750 + Math.random() * 500, function (): void {

            this.animations.play("open-not-chosen", 12);

            if (this.rewardType !== GameConstants.NOTHING_REWARD) {
                this.game.time.events.add(300, function (): void {
                    this.reward.visible = true;
                }, this);
            }

            AudioManager.getInstance().playEffect("moneda");

        }, this);
    }

    private onRewardHit(body: any, shapeA: any, shapeB: any, equation: any): void {

        if (DailyRewardItemsContainer.trunkHit) {
            return;
        }

        DailyRewardItemsContainer.trunkHit = true;

        this.trunkHit = true;

        this.animations.play("open-prize", 12);

        this.game.time.events.add(300, function (): void {

            this.reward.visible = true;
            this.rays.visible = true;

            this.game.add.tween(this.rays)
                .to({ angle: 360 }, 6000, Phaser.Easing.Linear.None, true)
                .loop();

            // avisar al tournament model
            GameManager.onDailyRewardItemHit(this.rewardType);

        }, this);

        AudioManager.getInstance().playEffect("moneda");
    }

    private addReward(): void {

        this.rays = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "rays");
        this.rays.anchor.setTo(.5, .5);
        this.rays.scale.setTo(1.5, 1.5);
        this.rays.blendMode = 3;
        this.rays.visible = false;
        this.addChild(this.rays);

        var rewardTextureName: string;

        switch (this.rewardType) {

            case GameConstants.HIGH_CREDITS_REWARD:
                rewardTextureName = "reward_top_coins";
                break;
            case GameConstants.MEDIUM_CREDITS_REWARD:
                rewardTextureName = "reward_medium_coins";
                break;
            case GameConstants.LOW_CREDITS_REWARD:
                rewardTextureName = "reward_low_coins";
                break;
            case GameConstants.FREEZE_GOALKEEPER_REWARD:
                rewardTextureName = "reward_freeze";
                break;
            case GameConstants.THREE_EXTRA_BALLS_REWARD:
                rewardTextureName = "reward_3_balls";
                break;
            case GameConstants.BALL_OF_FIRE_REWARD:
                rewardTextureName = "reward_ball_fire";
                break;
            case GameConstants.VOODOO_REWARD:
                rewardTextureName = "reward_voodoo";
                break;
            case GameConstants.NOTHING_REWARD:
                rewardTextureName = Math.random() > .5 ? "prize_void_01" : "prize_void_02";
                break;
            default:
        }

        this.reward = new Phaser.Image(this.game, 0, 0, "texture_atlas_6", rewardTextureName);
        this.reward.anchor.setTo(.5, .5);
        this.reward.visible = false;
        this.addChild(this.reward);
    }
}
